import axiosInstance from '../config/axios';

export const helpService = {
  sendHelpRequest: (comment) => 
    axiosInstance.post('/help/send-request', { comment }).then(res => res.data),
};
